<div class="alerts">
    <div class="alerts-header">
        <h4>Alerts</h4>
        <button class="close-alerts" type="button" aria-label="Close alerts" (click)="onCloseClick()">&times;</button>
    </div>
    <div class="alerts-body">
        <div class="filters" *ngIf="!isLoading">
            <label class="search">
                <input type="text" [(ngModel)]="searchTerm" (input)="filterAlerts()" placeholder="Search alerts">
            </label>
            <label>
                <input type="checkbox" [(ngModel)]="showOpportunities" (change)="filterAlerts()"> Opps ({{ opportunityCount }})
            </label>
            <label>
                <input type="checkbox" [(ngModel)]="showLeases" (change)="filterAlerts()"> Leases ({{ leaseCount }})
            </label>
        </div>
        <div class="alerts-loading" *ngIf="isLoading">
            <div class="spinner"></div>
            <p>Loading alerts...</p>
        </div>
        <ul class="grid-list" *ngIf="!isLoading">
            <li *ngFor="let alert of filteredAlerts" (click)="onAlertClick(alert)">
                <h5>{{ alert.message }}</h5>
                <br>
                <h6 *ngIf="user.user?.admin===1">Assignee: {{alert.user.first_name}} {{alert.user.last_name}}</h6>
                <p>{{ alert.created_at }} <ion-icon *ngIf="alert.type=='email'" name="mail-open"></ion-icon><ion-icon *ngIf="alert.type=='message'" name="chatbubble"></ion-icon><span class="circle" *ngIf="!alert?.read"></span></p>
            </li>
        </ul>
    </div>
</div>
<div class="button" (click)="onViewAllClick()">
    VIEW ALL ALERTS
</div>
